import { createSlice } from '@reduxjs/toolkit';

// initialState.user is `null` when logged out; otherwise the user payload
// returned by POST /v1/login or GET /v1/validatesession
// (username, organization, groups, authMethod, canCreateDataset).
// Store the full object — read state.login.user.username (not state.login.user)
// when you only want the signum.
export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        value: false,
        user: null
    },
    reducers: {
        loggedIn: (state, action) => {
            state.value = true;
            // Backwards-compat: an older callsite may still dispatch a bare
            // username string. Wrap it so consumers can rely on the object.
            const payload = action.payload;
            state.user = (typeof payload === 'string')
                ? { username: payload, canCreateDataset: false, groups: [] }
                : payload;
        },
        loggedOut: (state) => {
            state.value = false;
            state.user = null;
        },
    },
});

// Action creators are generated for each case reducer function
export const { loggedIn, loggedOut } = loginSlice.actions;

export default loginSlice.reducer;
